import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "beian" }, "主办：丹阳市融媒体中心", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "beian",
  href: "https://beian.miit.gov.cn/#/Integrated/ComplaintA",
  style: {"text-decoration":"underline"}
}, "备案号：苏ICP备19041352号-5A", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}